define('editor/edit/map/controls/title',['leaflet-title'], function () {
    var control = function (options) {
        var self = this;

        self.options = options;

        self.addToMap = function () {
            self.control = L.title({ text: self.options.editorMap.title });

            self.control.addTo(self.options.mapControl);
        };

        self.updateTitle = function (text) {
            self.control.setTitle(text);
        };

        self.remove = function () {
            self.control.remove();
        };
    };

    return control;
});

